var render = function render(_c,_vm){return _c('div',{staticClass:"page-single align-items-start"},[_c('div',{staticClass:"container-xl"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-sm col-lg-6 col-md-8 mx-auto"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }